import React, { useState, useEffect } from 'react';
import { getPedidos, getEstadisticas } from '../../services/api';

function Dashboard() {
  const [stats, setStats] = useState({
    hoy: 0,
    mañana: 0,
    semana: 0,
  });
  const [estadisticasMañana, setEstadisticasMañana] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const hoy = new Date();
      const mañana = new Date();
      mañana.setDate(mañana.getDate() + 1);

      const fechaMañana = mañana.toISOString().split('T')[0];

      // Obtener estadísticas de mañana
      const statsRes = await getEstadisticas(fechaMañana);
      setEstadisticasMañana(statsRes.data);

      // Contar pedidos de mañana
      const pedidosMañanaRes = await getPedidos({ fecha: fechaMañana });
      const totalMañana = pedidosMañanaRes.data.length;

      setStats((prev) => ({
        ...prev,
        mañana: totalMañana,
      }));
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  const mañana = new Date();
  mañana.setDate(mañana.getDate() + 1);
  const fechaMañana = mañana.toLocaleDateString('es-AR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Vista general del sistema de pedidos</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>{stats.mañana}</h3>
          <p>Pedidos para Mañana</p>
        </div>
        <div className="stat-card">
          <h3>{estadisticasMañana.length}</h3>
          <p>Platos Diferentes</p>
        </div>
      </div>

      <div className="card">
        <h2>Pedidos para {fechaMañana}</h2>
        {estadisticasMañana.length === 0 ? (
          <p style={{ color: '#7f8c8d' }}>
            Aún no hay pedidos para mañana
          </p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Categoría</th>
                <th>Plato</th>
                <th>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              {estadisticasMañana.map((item, index) => (
                <tr key={index}>
                  <td>{item.categoria}</td>
                  <td>{item.plato}</td>
                  <td>
                    <strong>{item.cantidad}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
